import { formatDate } from '@angular/common';
import {
  checkDefined,
  isValidData,
  UserSession
} from '@com-delta-idp/mnx-skymiles-shared';
import { AEMCampaignId, TYPE } from '../models';
import { PersonalizationEngineRequest } from '../models/api/personalization-engine.interfaces';

export const getPERequest = (
  aem: AEMCampaignId | undefined,
  userData: UserSession | undefined
): PersonalizationEngineRequest => {
  return isValidData<
    AEMCampaignId,
    [AEMCampaignId | undefined, UserSession | undefined]
  >('format', aem, userData)
    ? adaptPERequest(aem as AEMCampaignId, userData as UserSession)
    : ({} as PersonalizationEngineRequest);
};

const adaptPERequest = (
  aem: AEMCampaignId,
  userData: UserSession
): PersonalizationEngineRequest => {
  return {
    micromomentCampaignId: checkDefined(aem.micromoments),
    bannerCampaignId: checkDefined(aem.banner),
    offerCampaignId: checkDefined(aem.offers),
    membershipLevel: checkDefined(userData.membershipLevel),
    birthDay: false, // TODO(Arun): Need to get value from dashboard - Post MVP
    sevenDaysBeforeBirthday: false, // TODO(Arun): Need to get value from dashboard - Post MVP
    sevenDaysAfterBirthday: false, // TODO(Arun): Need to get value from dashboard - Post MVP
    skyMilesAnniversary: getSkyMilesAnniversary(userData.enrollmentDate),
    ageRestrict: userData.isAbove18 ? 'N' : 'Y',
    format: checkDefined(aem.format),
    amexCardMember: userData.cobrandCardtypeList ? 'Y' : 'N',
    newJoiner: getNewMember(userData.enrollmentDate),
    profileSetUp: !userData.hasPhone,
    currentDate: formatDate(new Date(), TYPE.DATE_FORMAT, TYPE.LOCALE),
    skyclub: getReserveCard(userData.cobrandCardtypeList)
  };
};

const getSkyMilesAnniversary = (enrollmentDate: string): boolean => {
  return checkEnrolledMonth(enrollmentDate) ? true : false;
};

const checkEnrolledMonth = (enrollmentDate: string): boolean => {
  return (
    new Date(enrollmentDate + 'T12:00:00Z').getMonth() ===
      new Date().getMonth() &&
    new Date(enrollmentDate + 'T12:00:00Z').getFullYear() !==
      new Date().getFullYear()
  );
};

const getNewMember = (enrollmentDate: string): boolean => {
  const dayDifference =
    (new Date().getTime() - new Date(enrollmentDate).getTime()) /
    (1000 * 60 * 60 * 24);
  return dayDifference <= 7 ? true : false;
};

const getReserveCard = (cardType: string): boolean => {
  let cardPresent = false;
  if (cardType) {
    cardType.split(':').forEach((type: string) => {
      if (['AXBV', 'AXCV'].includes(type)) {
        cardPresent = true;
      }
    });
  }
  return cardPresent;
};
